import type { PaymentMethodCreateParams } from '@stripe/stripe-js';

import { type BillingDetails } from '../../models/public-api';

/**
 * Maps billing details to Stripe DTO.
 * @param details Billing details.
 */
export function mapBillingDetailsToStripe(details: BillingDetails): PaymentMethodCreateParams.BillingDetails {
  return {
    name: `${details.firstName} ${details.secondName}`,
    address: {
      city: details.location.city ?? undefined,
      state: details.location.state?.abbreviation,
      line1: details.location.addressLine1,
      line2: details.location.addressLine2,
    },
  };
}
